import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { WizardPickerPage } from './pages/WizardPickerPage';
import { DivisionGridPage } from './pages/DivisionGridPage';
import { DivisionEditorPage } from './pages/DivisionEditorPage';
import { ColorPage } from './pages/ColorPage';
import { FloorPlanPage } from './pages/FloorPlanPage';
import { CartPage } from './pages/CartPage';
import { AgendaPage } from './pages/AgendaPage';
import { useEmbedBridge } from './hooks/useEmbedBridge';
import { loadProject } from './lib/projectApi';

// Q35: if the URL carries a resume link (?p=<id>&t=<token>), hydrate the saved
// project into the store and jump to its wizard before rendering routes.
function useResumeLink(): boolean {
  const navigate = useNavigate();
  const [resolving, setResolving] = useState(() => {
    const q = new URLSearchParams(window.location.search);
    return Boolean(q.get('p') && q.get('t'));
  });
  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const id = q.get('p'); const token = q.get('t');
    if (!id || !token) return;
    void loadProject(id, token).then((wizardType) => {
      navigate(wizardType ? `/wizard/${wizardType}` : '/', { replace: true });
      setResolving(false);
    });
  }, [navigate]);
  return resolving;
}

export function App() {
  useEmbedBridge();
  const resolving = useResumeLink();
  if (resolving) {
    return (
      <div className="grid min-h-screen place-items-center bg-smartify-paper p-6 text-center text-sm text-smartify-muted">
        A abrir o teu projeto guardado…
      </div>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/wizard" element={<WizardPickerPage />} />
      <Route path="/wizard/:type" element={<DivisionGridPage />} />
      <Route path="/wizard/:type/edit" element={<DivisionEditorPage />} />
      <Route path="/wizard/:type/cor" element={<ColorPage />} />
      <Route path="/wizard/:type/planta" element={<FloorPlanPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/agenda" element={<AgendaPage />} />
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
